module.exports = __webpack_public_path__ + "assets/zrownowazone-sr-i-technologia.3fb2565d.svg";